<template>
  <div class="table-responsive statistics-card">
    <div class="metric-switcher">
      <customer-metric :metric="getActiveLastWeekMetrics[index]">
      </customer-metric>
    </div>
    <div class="footer statistics-calculated">Updated: {{ getLastCalculatedDate }}</div>
    <div class="footer statistics-date-range">{{ getDateRange }}</div>
  </div>
</template>

<script>
import customerMetric from '../../components/dashboard/customerMetric';

export default {
  name: 'statistics-card',
  props: ['statistics'],
  components: { customerMetric },
  data() {
    return {
      index: 0
    }
  },
  computed: {
    getActiveLastWeekMetrics() {
      return _.filter(this.statistics.metrics, metric => {
        return metric.activeLastWeek === true;
      });
    },
    visible: (vue) => (index) => {
      return vue.index === index;
    },
    getLastCalculatedDate() {
      return moment.unix(this.statistics.calculatedAt._seconds).format('DD-MM-YYYY HH:mm')
    },
    getDateRange() {
      const start = moment.unix(this.statistics.fetchDateStart._seconds).utc();
      const end = moment.unix(this.statistics.fetchDateEnd._seconds).utc();
      return `Week ${start.isoWeek()} ${start.isoWeekYear()} tm week ${end.isoWeek()} ${end.isoWeekYear()}`
    }
  },
  created() {
    setInterval(() => {
      this.index++;
      if (this.index === this.getActiveLastWeekMetrics.length) {
        this.index = 0;
      }
    }, 5000);
  }
}
</script>

<style lang="scss">

.statistics-card {
  height: 800px;
  background-color: white;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr auto;
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
}


.metric-switcher {
  grid-area: 1 / 1 / 2 / 3;
}

.footer {
  font-size: 2rem;
  color: gray;
  padding: 3rem;
  font-style: italic;
}

.statistics-calculated {
  text-align: left;
}

.statistics-date-range {
  text-align: right;
}

</style>